import { useNewsletterContext } from "@omni/components/components/Newsletter/context/newsletter.context";
import { cn } from "@omni/utils/styles";

const TitleComponent = () => {
    const { helperText, isBold } = useNewsletterContext();
    return (
        <div
            className={cn("h5 tw:mt-0 tw:text-center tw:md:text-left", {
                "tw:font-bold": isBold
            })}
        >
            {helperText}
        </div>
    );
};

export { TitleComponent };
